import styled from 'styled-components';
import DocumentsUpload from './DocumentsUpload';
import { colorSchema, media } from 'utils/style';
import { STATUS } from 'utils/constants/documents';

export default styled(DocumentsUpload)`
  .documents-upload {
    display: flex;
    flex-direction: column;

    &__title {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
      font-weight: bold;
      margin-bottom: 0.8rem;
      text-transform: uppercase;
    }

    &__item {
      background-color: ${colorSchema('white')};
      border-radius: 4px;
      border: 1px solid ${colorSchema('grey300')};
      display: flex;
      flex-direction: column;
      margin-bottom: 0.8rem;
      padding: 1.6rem;
      ${media.greaterThan('tablet')`
        align-items: center;
        border-bottom:0 ;
        border-radius: 0;
        flex-direction: row;
        margin-bottom: 0;

        &--hide {
          display: none;
        }

        &--next-face {
          height: 65px;
        }
      `}
    }

    &__tag-container {
      margin-bottom: 1.6rem;
      text-transform: uppercase;
      flex-direction: ${(props) =>
        props.document.status === STATUS.status_invalid ? 'column' : 'row'};
      row-gap: 1.5rem;
      ${media.greaterThan('tablet')`
        display: flex;
        justify-content: flex-start;
        order: 3;
        margin-bottom: 0;
        margin-right: 3.8rem;
        align-items: flex-start;
        width: 255px;
      `};
    }

    &__doc-title {
      color: ${colorSchema('grey900')};
      font-size: 1.8rem;
      font-weight: 500;
      margin-bottom: 0.8rem;
      ${media.greaterThan('tablet')`
        font-size: 1.6rem;
        margin-bottom: 0;
        margin-right: 1.6rem;
        order: 0;
        &--push-side {
          margin-right: auto;
        }
      `}
    }

    &__link {
      ${media.greaterThan('tablet')`
        margin-right: auto;
        order: 1;
      `}
    }

    &__link-text {
      color: ${colorSchema('primary500')};
      font-size: 1.4rem;
      font-weight: normal;
    }

    &__link-text-error {
      color: ${colorSchema('error900')};
      font-size: 1.4rem;
      font-weight: normal;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      margin-top: 2.4rem;
      ${media.greaterThan('tablet')`
        margin-top:0;
        order: 4;
      `}
    }

    &__expire-container {
      align-items: center;
      display: flex;
      ${media.greaterThan('tablet')`
        display: none;
        margin-right: 4.2rem;
        width: 68px;
      `}
    }

    &__expire-label,
    &__expire-value {
      font-size: 1.6rem;
      font-weight: normal;
    }

    &__expire-label {
      color: ${colorSchema('greyWolf')};
      margin-right: 0.4rem;
      ${media.greaterThan('tablet')`
        display: none;
      `}
    }

    &__expire-value {
      color: ${(props) =>
        props.document.status === STATUS.status_close_to_expire
          ? colorSchema('accent900')
          : colorSchema('grey800')};
      &--alone {
        display: none;
      }
      ${media.greaterThan('tablet')`
        display: none;
        font-weight: 500;
        &--alone {
          display: flex;
          order: 2;
          margin-right: 6.2rem;
        }
      `}
    }

    &__optional-tag {
      display: flex;
      order: 2;
      margin-right: 1.6rem;
      font-size: 14px;
    }

    &__button {
      width: auto;
      display: block;
      ${media.greaterThan('tablet')`
        height: 32px;
        width: 162px;

        &--auto {
          width: auto;
        }
      `}

      button {
        border-radius: 4px;
        width: 100%;
        ${media.greaterThan('tablet')`
          height: 32px;
        `}
      }
    }

    &__droparea {
      display: none;
      ${media.greaterThan('tablet')`
        display: flex;
      `}
    }

    &__drop-container {
      align-items: center;
      background: ${colorSchema('white')};
      border: 1px dashed ${colorSchema('grey300')};
      display: none;
      height: 64px;
      justify-content: space-between;
      padding: 1.6rem;
      width: 100%;
      &:before {
        content: '';
      }
      &--show {
        display: flex;
      }
    }

    &__drop-help {
      color: ${colorSchema('grey700')};
      max-width: 193px;
      text-align: center;
    }

    &__drop-button {
      border-radius: 4px;
      height: 32px;
      width: 143px;
    }

    &__example-modal {
      display: flex;
      justify-content: center;
      padding: 1.6rem;
      max-height: 500px;

      ${media.greaterThan('tablet')`
        width: 382px;
      `}
    }

    &__example-image {
      height: auto;
      max-height: 500px;
      max-width: 100%;
      width: auto;

      ${media.greaterThan('tablet')`
        max-width: 382px;
      `}
    }

    &__next-side {
      align-items: center;
      display: flex;
      flex-direction: column;
      width: 100%;

      ${media.greaterThan('tablet')`
        flex-direction: row;
        justify-content: space-between;
      `}
    }

    &__next-side-label {
      font-size: 1.8rem;
      color: ${colorSchema('grey900')};
      line-height: 1.28;
      order: 1;
      margin-bottom: 3rem;

      ${media.greaterThan('tablet')`
        color: ${colorSchema('grey700')};
        font-size: 1.6rem;
        line-height: auto;
        margin-bottom: 0;
        margin-right: 2rem;
        order: 0;
      `}
    }

    &__next-side-action {
      align-self: flex-end;
      display: flex;
      order: 2;

      ${media.greaterThan('tablet')`
        order: 1;
      `}
    }

    &__finish {
      margin-right: 1.6rem;
    }

    &__upload-other {
      margin-right: 0.8rem;
    }

    &__cancel-icon {
      align-self: flex-end;
      order: 0;
      width: auto;

      ${media.greaterThan('tablet')`
        align-self: center;
        order: 3;
      `}

      svg {
        fill: ${colorSchema('grey500')};
      }

      button {
        width: 1.6rem;
        height: 1.6rem;
      }
    }

    &__spinner {
      fill: ${colorSchema('primary700')};
      animation: rotate 1s infinite linear;
      height: 16px;
      order: 3;
      stroke: ${colorSchema('primary700')};
      width: 16px;
    }

    &__tooltip-error {
      color: ${colorSchema('grey900')};
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
